var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('v-img',{class:_vm.rounded ? 'rounded' : '',attrs:{"src":_vm.src,"lazy-src":_vm.lazySrc,"height":_vm.height,"width":_vm.width,"aspect-ratio":_vm.aspectRatio,"contain":_vm.contain}},[_vm._t("default")],2):_c('v-sheet',{class:[
    'd-flex',
    'align-center',
    'justify-center',
    _vm.rounded ? 'rounded' : '',
  ],attrs:{"height":_vm.height,"width":_vm.width,"color":"accent"}},[_c('v-icon',{attrs:{"size":_vm.iconSize,"color":"grey"}},[_vm._v(_vm._s(_vm.placeholderIcon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }